import React, { useCallback, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper'
import NavigationHeder from '../../Navigations/NavigationHeder'
import ButtonNew from '../../inc/ButtonNew'
import AgGridNew from '../../grid/ag/ag-grid-new'
import OperationMappingFormsPopup from './OperationMappingFormsPopup'
import Api from '../../../inc/Api'
import Settings from '../../../inc/Settings'
import Helper from '../../../inc/Helper'
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation'
import { useNavigate } from 'react-router-dom'
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions'
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls'
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown'

let gridApi = null;
const OperationMappingFormsListings = () => {
  const [openPopupView, setOpenPopupView] = useState(false);
  
  const [apiMaster, setApiMaster] = useState([]);
  const [sources, setSources] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {  
    fetchDataForSystemDetails();
  }, [])

  const fetchDataForSystemDetails = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemApiMasterResponse = await apiCalls.getSystemApiDetails();
      const systemSourcesResponse = await apiCalls.getSystemSourceMaster();

      if (systemApiMasterResponse) {
        setApiMaster(systemApiMasterResponse);
      };
      if(systemSourcesResponse) {
        setSources(systemSourcesResponse);
      };
    } catch (error) { 
      setApiMaster([]); 
      setSources([]);
    }
  }
  
  const onClickRedirectToDetailView = (event) => {   
    if(event.colDef.field === 'operation_name') { 
      navigate(`/edit-operation-mapping-form/${event?.data?.operation_id}`)
    }
  }

  const onClickPopupView = () => {
    setOpenPopupView(true);
  }

  const onDeleteIntegrationDocument = useCallback(async (element) => { 
    let api = Api;
    api.setUserToken();
    
    let delDocument_ID = element?.data?.operation_id;

    try {
      const res = await api
      .axios()
      .delete(Settings.apiAppUrl+`/operation-mapping/${delDocument_ID}/`)

      const rowNode = gridApi?.getRowNode(delDocument_ID)
      
      if (rowNode) {
        rowNode.setSelected(false)
      }
      
      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.applyServerSideTransaction(transaction) 
      }, 200);

      gridApi?.refreshServerSide({ purge: true })
      gridApi?.deselectAll();
      
      Helper.alert(res?.data?.message || 'Operation mapping deleted successfully', 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const reloadParentGrid = () => {
    gridApi?.refreshServerSide({ purge: true });
    gridApi?.deselectAll();
  };
 
  const gridColumnHeaders = [
    {field:'operation_name', filter: 'agTextColumnFilter', headerName:'Operation name', editable:false, cellRenderer: (params) => gridLinkValueFormat(params) },
    {field:'parameters', headerName:'Parameters', editable: false },
    {field:'response_type', headerName:'Response type', editable: false },
    {
      field:'is_active', 
      editable: false, headerName: 'is Active', 
      cellRenderer: 'agCheckboxCellRenderer',
      cellRendererParams: { disabled: true },
      valueGetter: (params) => {
        if(!params?.data?.is_active || !params?.data){
          return false
        }
        else {
          return params.data?.is_active
        }
      }
    },
    {
      field: 'api',
      headerName: 'Api',
      editable: false, 
      isAllowZero: true,
      cellEditor: SimpleDropdown,
      minWidth: 180,  
      cellEditorParams: {
        values: apiMaster
      },
      cellDataType: false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    }, 
    {
      field: 'source',
      headerName: 'Source',
      editable: false, 
      isAllowZero: true,
      cellEditor: SimpleDropdown,
      minWidth: 180,  
      cellEditorParams: {
        values: sources
      },
      cellDataType: false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    }
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'Operation Mapping'}>
        <ButtonNew onClick={onClickPopupView} title={'New'}  />
      </NavigationHeder>

      <AgGridNew
        apiUrl={Settings.apiAppUrl+'/operation-mapping/'} 
        pagination={false}
        columnDefs={gridColumnHeaders} 
        hideAddBtn={true}
        height={500}
        uniqueField={'operation_id'}
        onCellClicked={onClickRedirectToDetailView}
        handleDeleteSelectedRows={onDeleteIntegrationDocument}
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"operation_mapping_forms_listing_grid"}
      />

      {openPopupView && <OperationMappingFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
    </div>
  )
}

export default (MasterComponentWraper(OperationMappingFormsListings))